export default {"src":"https://s.sylndr.com/c-e456acf/_next/static/media/arrow-down-primary.ce9fd849.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};